import React, { useState, useEffect, useCallback, Fragment, memo } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from "../Auth";
import  {          
            Button,
            Checkbox,
            Chip,
            Dialog,
            DialogActions,
            DialogContent,
            Fab,
            FormControlLabel,
            Grid,
            Grow,
            IconButton,
            LinearProgress,
            Menu,
            MenuItem,
            Paper,
            Slider,
            Switch,          
            TableBody,
            TableHead,
            TablePagination,
            TableSortLabel,
            TableRow,
            TextField,
            Tooltip,
            withWidth
} from '@material-ui/core';
import { 
            Add as AddIcon,
            Autorenew as AutorenewIcon,
            BorderVertical as BorderVerticalIcon,
            Brush as BrushIcon,
            CheckBox as CheckBoxIcon,
            CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
            Clear as ClearIcon,
            DateRange as DateRangeIcon,
            Delete as DeleteIcon,
            Description as DescriptionIcon,
            FilterList as FilterListIcon,
            MarkunreadMailbox as MarkunreadMailboxIcon,
            MoreVert as MoreVertIcon,
            NavigateNext as NavigateNextIcon,
            PictureAsPdf as PictureAsPdfIcon,
            PlusOne as PlusOneIcon,
            Save as SaveIcon,
            Search as SearchIcon,
            Visibility as VisibilityIcon,
            ViewWeek as ViewWeekIcon,
} from '@material-ui/icons';
import FacebookCircularProgress from '../Elementos/FacebookCircularProgress';
import styled from 'styled-components';
import { Autocomplete } from '@material-ui/lab';
import Swal from 'sweetalert2';
import { 
    DatePicker,
    Modal as ModalAntd,
} from 'antd';
import PdfElement from '../Elementos/PdfElement';
import ExcelComponent from '../Elementos/ExcelComponent';
import {
    TableContainerYounet,
    TableYounet,
    TheadYounetStyledFixed,
    TheadYounetStyled,
} from '../Elementos/TablaContainerYounet';
const moment = require('moment-timezone');  


    const useStyles = makeStyles((theme) => ({
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2),
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1,
            color:'#fff'
        },
    }));

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Grow direction="up" ref={ref} {...props} timeout={750} />;
    });

    const TdYounetStyledFixed = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '12px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        min-width:${props => props.width || 60};
        width:${props => props.width || 60};
        padding-top:${props => props.element ? '0px' : '5px'}; 
        text-align:${props => props.align ? props.align : 'left'};
        background:#ffffff;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:43px;
        max-height:43px;
        padding:10px; 
        position:sticky;
        z-index:1; 
        left:${props => props.left || '0px'};
        text-overflow: ellipsis; 
        white-space: nowrap;  
        overflow: hidden;
    `;

    const TdYounetStyled = styled.td`
        color:${props => props.color ? props.color : 'black'};
        font-size:${props => props.fontSize ?  props.fontSize : '12px'};
        font-weight:${props => props.bolder ? 'bold' : 'none'};
        min-width:${props => props.width || 60};
        width:${props => props.width || 60};
        padding-top:${props => props.element ? '0px' : '5px'}; 
        text-align:${props => props.align ? props.align : 'left'};
        background:transparent;
        border-bottom: 1px solid #E5E8E8;
        display:block;
        height:43px;
        max-height:43px;
        padding:10px;   
        position:relative;
        left:0px;      
        text-overflow: ellipsis;    
        white-space: nowrap; 
        overflow: hidden;
    `;

    const TrYounetStyled = styled.tr`
        display:flex;
        position:'sticky';
        top:0px;
        z-index:2;
        background-color:${props => props.selected ? 'LightBlue' : '#fff'};
        &:hover{
            background-color:Gainsboro
        }
    `;

    const headCellsColumn = [
        { id: 'Nombres', numeric: true, disablePadding: false, label: 'Cliente', show:true, fixed:false, width:400, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'CI', numeric: true, disablePadding: false, label: 'CI', show:true, fixed:false, width:170, num:1, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'ageWork', numeric: true, disablePadding: false, label: 'Age Work', show:true, fixed:false, width:130, num:2, align:'left', fontSize:'16px', bolder:false, type:'number' },
        { id: 'idForMikrotik', numeric: true, disablePadding: false, label: 'idForMikrotik', show:true, fixed:false, width:265, num:3, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'fechaCortePromesa', numeric: false, disablePadding: false, label: 'Corte Promesa', show:true, fixed:false, width:180, num:4, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'fechaCorte', numeric: false, disablePadding: false, label: 'Corte Original', show:true, fixed:false, width:180, num:5, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'NumberReciept', numeric: false, disablePadding: false, label: 'Num. Recibo', show:true, fixed:false, width:170, num:6, align:'left', fontSize:'16px', bolder:false , type:'text'    },
        { id: 'Status', numeric: false, disablePadding: false, label: 'Status', show:true, fixed:false, width:160, num:7, align:'left', fontSize:'16px', bolder:false , type:'text'    },
    ];

    const variablesObject = {
        api:'/api/PromesasRecibos',
        apiMultiples:'/api/PromesasRecibos/Multiples',
        label:'PROMESA',
        nameLocalStorage:'headersPromesasAC',
        sumWidth:'100vw',
        title:'PROMESAS',
    };

    const propsWidth = {
        numpro: 80,
        OT: 80,
        Proyecto: 300,
        NumGar: 100,
        Cliente:300,
        CanElem:100,
        TipTra:210,
        Ejecutiva: 200,
        Cadena:100,
        Local:100,
        FecIns:170,
        FecVen:170,
        MotGar:200,
        ObservacionGar:200,
        Codigo:100,
        Status:90,
        FechaInicio: 200,
        FechaTermino: 200,
        FechaTerminoReal: 200,
        ObservacionSuper:240,
        Fotos:100,
        Creacion:100,
        Action:80,
        TipGar:120
    };

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
          return -1;
        }
        if (b[orderBy] > a[orderBy]) {
          return 1;
        }
        return 0;
    };
      
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    };
      
    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    };

    const TheadYounetFixed = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, headCells, align})=>{
        const [ leftValue, setLeftValue ] = useState('0px')
        
        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i<headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
                setLeftValue(`${numero}px`)
            }
            
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        return(
            <TheadYounetStyledFixed width={widthDefault} left={leftValue} align={align}>
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)} 
                    style={{color:'#fff', textAlign:align}}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                    ) : null}
                </TableSortLabel>
            </TheadYounetStyledFixed>
        );
    });

    const TheadYounet = memo(({widthDefault, createSortHandler, order, orderBy, headCell, classes, align})=>( 
        <TheadYounetStyled width={widthDefault} align={align}>
            <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)} 
                style={{color:'#fff', textAlign:align}}
            >
                {headCell.label}
                {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
                ) : null}
            </TableSortLabel>
        </TheadYounetStyled>
    ));

    const TdYounet = memo(((props)=>{
        const { minWidth, width, headCells, headCell, valueInfo, fixed, color, align, bolder, fontSize } = props
        const [ leftValue, setLeftValue ] = useState('0px');

        useEffect(()=>{
            if(headCell.num === 0){
                setLeftValue('0px');
            }else{
                let numero = 0;
                for(let i=0; i < headCell.num; i++){
                    if(headCells[i].fixed) numero += headCells[i].width;
                }
               
                setLeftValue(`${numero}px`)
            }
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        
        return(
            <Fragment>
            {
                fixed ?
                <TdYounetStyledFixed 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo}
                </TdYounetStyledFixed>
                :
                <TdYounetStyled 
                    minWidth={minWidth} 
                    width={width} 
                    left={leftValue} 
                    color={color} 
                    bolder={bolder}
                    fontSize={fontSize}
                    align={align}
                >
                    {valueInfo}
                </TdYounetStyled>
            }
            </Fragment>
        )
        
        
    }));

    function EnhancedTableHead(props) {
        
        const { classes, order, orderBy, onRequestSort, headCells, HandleChangeWidth } = props;

        const createSortHandler = (property) => (event) => {
          onRequestSort(event, property);
        };
    
        return (
            <TableHead style={{position:'sticky', top:0, zIndex:2}}>
                <TableRow style={{display:'flex'}} >
                    <TheadYounetStyled width={140} align='left'>
                        ACTIONS
                    </TheadYounetStyled>
                {headCells.map( headCell =>  
                    headCell.show && ( 
                        headCell.fixed 
                        ? 
                        <TheadYounetFixed  
                            headCells={headCells} 
                            HandleChangeWidth={HandleChangeWidth} 
                            key={headCell.id} 
                            widthDefault={headCell.width} 
                            createSortHandler={createSortHandler} 
                            order={order} 
                            orderBy={orderBy} 
                            headCell={headCell} 
                            classes={classes} 
                            align={headCell.align}
                            
                            />
                        : 
                        <TheadYounet  
                            headCells={headCells} 
                            HandleChangeWidth={HandleChangeWidth}
                            key={headCell.id} 
                            widthDefault={headCell.width} 
                            createSortHandler={createSortHandler} 
                            order={order} 
                            orderBy={orderBy} 
                            headCell={headCell} 
                            classes={classes} 
                            align={headCell.align}
                         />
                        
                ))}
                </TableRow>
            </TableHead>
        );
    };
    
    const FiltradoEl = ({ index, info, HandleAddFilter, HandleDeleteFilter, HandleAddInformacionFilter, headersColumn})=>{
        const [ elementValue, setElementValue ] = useState({ idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'O', type:''});

        useEffect(()=>{
            setElementValue({ idElement:info.idElement, valorElement:info.valorElement, numero:index, labelElement:info.labelElement, selectElement:info.selectElement, type:info.type})
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        const HandleElementValue = (e)=>{
            setElementValue({...elementValue, valorElement:e.target.value});
           // HandleAddInformacionFilter(index, e.target.id, e.target.value)
        };

        const HandlePreDeleteFilter = ()=>{
            HandleDeleteFilter(index);
        };

        const HandlePreAddInfFilter = (e)=>{
            HandleAddInformacionFilter(elementValue)
        };

        const HandleAutoComplete = (e, value)=>{
            if(value === '' || value === null){
                setElementValue({...elementValue, idElement:'', labelElement:'', valorElement:''});
            }else{ 
                const arrFilHeaders = headersColumn.filter(value2=> value2.label === value);
                if(arrFilHeaders.length > 0){
                    setElementValue({...elementValue, idElement:arrFilHeaders[0].id.toString(), labelElement:value, type:arrFilHeaders[0].type.toString()});
                }
            }
            
        };

        const HandleSelectElement = (e)=>{
            setElementValue({...elementValue, selectElement:e.target.value});
        };

        if(index === 0){
            return( 
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12}  key={`ElementMenu-Filtrado-${index}`}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5} style={{paddingTop:12}}>
                            <Autocomplete
                                id={`idElement-${index}`}
                                options={headersColumn}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                inputValue={elementValue.labelElement || ''}
                                onInputChange={HandleAutoComplete}
                                size='small'
                            />
                        </Grid>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5}>
                            {
                                elementValue.type === 'number' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='number'
                                />: elementValue.type === 'date' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='date'
                                />: 
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                />
                            }
                        </Grid>
                        <Grid item xl={1} lg={2} md={2} sm={2} xs={2}>
                            <IconButton style={{marginTop:5}} onClick={HandleAddFilter}>
                                <AddIcon color='primary'/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            )
        }else{ 
            return(
                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} key={`ElementMenu-Filtrado-${index}`}>
                    <Grid container justifyContent='center' spacing={1} >
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={5} style={{paddingTop:12}}>
                            <Autocomplete
                                id={`idElement-${index}`}
                                options={headersColumn}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                inputValue={elementValue.labelElement || ''}                               
                                onInputChange={HandleAutoComplete}
                                size='small'
                            />
                        </Grid>
                        <Grid item xl={5} lg={5} md={5} sm={5} xs={4}>
                            {
                                elementValue.type === 'number' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='number'
                                />:elementValue.type === 'date' ?
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                    type='date'
                                />:
                                <TextField 
                                    id={`valorElement-${index}`}
                                    value={elementValue.valorElement ||''}
                                    onChange={HandleElementValue}
                                    fullWidth
                                    margin='dense'
                                    label='Valor'
                                    variant='outlined'
                                    onBlur={HandlePreAddInfFilter}
                                />
                            }
                            
                        </Grid>
                        <Grid item xl={2} lg={2} md={2} sm={2} xs={3} >
                            <TextField
                                id={`selectElement-${index}`}
                                select
                                value={elementValue.selectElement || ''}
                                onChange={HandleSelectElement}
                                style={{marginTop:15}}
                                onBlur={HandlePreAddInfFilter}
                                margin='dense'
                            >
                                <MenuItem value={'O'}>O</MenuItem>
                                <MenuItem value={'Y'}>Y</MenuItem>
                            </TextField>
                            <IconButton onClick={HandlePreDeleteFilter} style={{marginTop:5}} id={`bu-${index}`}>
                                <DeleteIcon style={{color:'red'}}/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>                                
            )
        }
    };

    const Roow = memo((props)=>{
        const { 
            row, 
            index, 
            headCells, 
            handleClickRow, 
            handleDeleteRow,
            selectionArr
        } = props;
        const [ statusRow, setStatusRow ] = useState(false);
        const [ continuoStatus, setContinuoStatus ] = useState(false);

        useEffect(()=>{
            const arrMap = selectionArr.filter(el=>el._id === row._id);
            arrMap.length > 0 && setStatusRow(true);
        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(continuoStatus){
                setContinuoStatus(false);
                if(statusRow){
                    handleClickRow(statusRow, row)
                }else{
                    handleClickRow(statusRow, row)
                }
            }
        },[continuoStatus]); // eslint-disable-line react-hooks/exhaustive-deps

        const handleAlertDelete = ()=>{
            Swal.fire({
                title:`DESEA ELIMINAR ESTA ${variablesObject.label}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if (result.isConfirmed) handleDelete()
            })
        };
    
        const handleDelete =  ()=>{
            fetch('/api/PromesasRecibos',{ method:'DELETE', body: JSON.stringify({_id:row._id}), headers:{'Content-Type': 'application/json'}}) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    Swal.fire({
                        title: result.message,
                        icon:'success',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    }).then((result) => {
                        handleDeleteRow(row._id);
                    })
                }else{
                    Swal.fire({
                        title: result.status,
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    })
                }
                
            })
        };


        const HeadCellArr = headCells.map((value, index2)=>( 
            <Fragment key={`${index}_${index2}_${row._id}`} >
                { value.show &&
                    <TdYounet 
                        key={`${index}_${index2}_${row._id}_Td`}
                        width={value.width} 
                        minWidth={propsWidth[value.field]} 
                        headCells={headCells} 
                        headCell={value} 
                        valueInfo={row[value.id]}
                        fixed={value.fixed}
                        align={value.align}
                        fontSize={value.fontSize}
                        bolder={value.bolder}
                    />
                }
            </Fragment>
        ));



        const HandlePreClickRow = ()=>{
            setStatusRow(!statusRow);
            setContinuoStatus(true);
        };

        return(
            <TrYounetStyled key={`fila-${row._id}`}  selected={statusRow}>
                <TdYounetStyled minWidth={140} width={140}>
                    <Grid container spacing={1} style={{height:32, marginTop:-10}}>
                        <Grid item >
                            <Checkbox
                                checked={statusRow}
                                color='primary'
                                onClick={HandlePreClickRow}
                                style={{marginTop:-4}}
                                size='small'
                            />
                        </Grid>

                        <Grid item >
                            <Tooltip title={`ELIMINAR`} placement='top' arrow>
                                <span>
                                    <IconButton aria-label="expand row" size="small" onClick={handleAlertDelete} color='primary'>
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>  
                    </Grid>
                </TdYounetStyled>
                { HeadCellArr }
            </TrYounetStyled>
        );
    });

    const RowHeadersStyle = memo(({rowInfo, HandleProcessHeaders, widthWin})=>{

        const { id, numeric, disablePadding, label, show, fixed, width, num, align, fontSize, bolder, type } = rowInfo;
        const [ infoRow, setInfoRow ] = useState({ id, numeric, disablePadding, label, show, fixed, width, num, align, fontSize, bolder, type });

        const HandleInformacion = (e)=>{
            setInfoRow({...infoRow, [e.target.name]:e.target.value})
        };

        const HandleSwitch = (e)=>{
            setInfoRow({...infoRow, bolder:e.target.checked})
        };

        const HandleProcess = ()=>{
            HandleProcessHeaders(infoRow);
        };

        const handleChangeWidth = (e, value)=>{
            setInfoRow({...infoRow, width:value})
        };

        const HandleReset = ()=>{
            const element = headCellsColumn.filter(value=> value.id === rowInfo.id)[0];
            HandleProcessHeaders(element);
        };

        return(
            <Paper elevation={2} style={{width:'100%', padding:10}}>
                <Grid container spacing={1}>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2} style={{height:40}}>
                        {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xs={3}>
                                        <Tooltip  title='GUARDAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={HandleProcess} >
                                                <SaveIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Tooltip  title='RESET' placement='top'>
                                            <Fab color="secondary" size='small' onClick={HandleReset} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item style={{textTransform:'uppercase', fontWeight:'bolder'}}>
                                        <Chip label={rowInfo.label}  color='secondary'style={{marginTop:5}}/>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item style={{marginTop:2}}>
                                        <Button size='small' variant='contained' color='primary' onClick={HandleProcess} endIcon={<SaveIcon/>}> GUARDAR </Button> 
                                    </Grid>
                                    <Grid item style={{marginTop:2}}>
                                        <Button size='small' variant='contained' color='primary' onClick={HandleReset} endIcon={<AutorenewIcon/>}> RESET </Button> 
                                    </Grid>
                                    <Grid item style={{textTransform:'uppercase', fontWeight:'bolder'}}>
                                        <Chip label={rowInfo.label}  color='secondary'/>
                                    </Grid>
                                </Fragment>
                            } 
                        </Grid>
                    </Grid>
                    <Grid item>
                        <TextField 
                            id={`${rowInfo.id}_${rowInfo.label}`}
                            name={'align'}
                            value={infoRow.align ||''}
                            onChange={HandleInformacion}
                            fullWidth
                            margin='dense'
                            variant='outlined'
                            label='Alinear Texto'
                            select
                        >
                            <MenuItem  value={'left'}>
                                IZQUIERDA
                            </MenuItem>
                            <MenuItem  value={'center'}>
                                CENTRADO
                            </MenuItem>
                            <MenuItem  value={'right'}>
                                DERECHA
                            </MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item>
                        <TextField 
                            id={`${rowInfo.id}_${rowInfo.label}`}
                            name={'fontSize'}
                            value={infoRow.fontSize ||''}
                            onChange={HandleInformacion}
                            fullWidth
                            margin='dense'
                            variant='outlined'
                            label='Tamaño Texto'
                        />
                    </Grid>
                    <Grid item style={{width:100}}>
                        <Slider 
                            value={infoRow.width} 
                            onChange={handleChangeWidth} 
                            aria-labelledby="continuous-slider" 
                            step={5}
                            min={50}
                            max={600}
                        />
                        <p>Ancho:{infoRow.width}</p>
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                            <Switch
                                checked={infoRow.bolder}
                                onChange={HandleSwitch}
                                id={`${rowInfo.id}_${rowInfo.label}`}
                                color="primary"
                            />
                            }
                            label={'Negritas'}
                        />
                    </Grid>
                </Grid>
            </Paper>
        );      
    });

    const Elemento = ({widthWin})=>{
        const classes = useStyles();
        const { setOpen, authTokens, setRuta } = useAuth();
        const { enqueueSnackbar } = useSnackbar();
        const [ rows, setRows ] = useState([]);
        const [ rows_, setRows_ ] = useState([]);
        const [ backupsRow, setBackupsRow ] = useState([]);
        const [ order, setOrder] = useState('desc');
        const [ orderBy, setOrderBy] = useState('fechaCortePromesa');
        const [ page, setPage] = useState(0);
        const [ rowsPerPage, setRowsPerPage] = useState(11);
        const [ headersColumn, setHeadersColumn ] = useState(()=>{
            try{
                if(window.localStorage.getItem(variablesObject.nameLocalStorage)){
                    const headersStorage = window.localStorage.getItem(variablesObject.nameLocalStorage) ;
                    const headersParse = JSON.parse(headersStorage);
                    return headersParse
                }else{
                    return headCellsColumn
                }
            }catch(err){
                console.log(err);
                return headCellsColumn
            }
        });
        const [ openMenuColumn, setOpenMenuColumn ] = useState(null);
        const [ openMenuColumnFixed, setOpenMenuColumnFixed ] = useState(null);
        const [ isSavingHeaders, setSavingHeaders ] = useState(false);
        const [ openMenuFilter, setOpenMenuFilter ] = useState(false);
        const [ openMenuDate, setOpenMenuDate ] = useState(null);
        const [ openMenuPdf, setOpenMenuPdf ] = useState(null);
        const [ openMenuExcel, setOpenMenuExcel ] = useState(null);
        const [ openMenuStyles, setOpenMenuStyles ] = useState(false);
        const [ openMenuPosicion, setOpenMenuPosicion ] = useState(false);
        const [ arrFiltrado, setArrFiltrado ] = useState([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
        const [ elementDate, setElementDate ] = useState({ idElement:'', labelElement:'', Inicio:'', Final:''});
        const [ isFilterDate, setFilterDate ] = useState(false);
        const [ isFilterNow, setFilterNow ] = useState(false);
        const [ isElementFilterShow, setElementFilterShow ] = useState(true);
        const [ rowsFilter, setRowsFilter ] = useState([]);
        const [ rowsFilterDate, setRowsFilterDate ] = useState([]);
        const [ selectionArr, setSelectionArr ] = useState([]);
        const [ isReadyPdf, setReadyPdf ] = useState(false);
        const [ isSelectPdf, setSelectPdf ] = useState(false);
        const [ isContinuoPdf, setContinuoPdf ] = useState(false);
        const [ arrHeadersPdf, setArrHeadersPdf ]= useState([])
        const [ openSelectPersonsMail, setOpenSelectPersonsMail ] = useState(false);
        const [ Remitentes, setRemitentes ] = useState([]);
        const [ RemitentesAll, setRemitentesAll ] = useState([]);
        const [ isCharging, setCharging ] = useState(true);
        const [ dataZona, setDataZona ] = useState([]);
        const [ dataClientes, setDataClientes ] = useState([]);
        const [ zonaSelected, setZonaSelected ] = useState('');
        const [ zonaSelectedObject, setZonaSelectedObject ] = useState({});
        const [ isSelectedZona, setSelectedZona ] = useState(false);
        const [ openFormulario, setOpenFormulario ] = useState(false);
        const [ formulario, setFormulario ] = useState({Nombres:'', CI:'', FechaPago:'', FechaCorte:'', Servicios:[{Direccion:''}], Referencia:''});
        const [ arrRecibosPendientes, setArrRecibosPendientes ] = useState([]);
        const [ reciboSelected, setReciboSelected ] = useState({
            fechaCortePromesa:(()=>{
            const laZona="America/Guayaquil";
            const laFecha = moment().tz(laZona).format();
            return laFecha;
            })()
        });
        const [ reciboPendiente, setReciboPendiente ] = useState('');
        const [ isSelectRecibo, setSelectRecibo ] = useState(false);
        const [ openConfirmacion, setOpenConfirmacion ] = useState(false);
        const [ isContinuoPromise, setContinuoPromise ] = useState(false);
        const [ isProcesing, setProcesing ] = useState(false);
        const [ getSearch, setSearch ] = useState('');
        const [ getOptionSearch, setOptionSearch ] = useState('Nombres'); 
        const [ isShowBusqueda, setShowBusqueda ] = useState(true);
        const [ openMenuBusqueda, setOpenMenuBusqueda ] = useState(null);
        const [ getContinuoUnSelect, setContinuoUnSelect ] = useState(false);
        
        useEffect(()=>{
            const handleUseEffect = async ()=>{
                setOpen(false); 
                setRuta('/Servicios/Promesas');
                const dataRec = await fetch(`/api/RecibosPendientes/PromesasbyEmpresa/${authTokens.Empresa}`);
                const infoRec = await dataRec.json();
                const dataZonas = await fetch(`/api/zonas/byEmpresa/${authTokens.Empresa}`);
                const resultZonas = await dataZonas.json();
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setDataZona(resultZonas);
                    setRows(infoRec);
                    setBackupsRow(infoRec);
                }else{
                    const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                    const arrFilZona = resultZonas.filter(value=> ZonasArr.includes(value.Zona?.toString()));
                    setDataZona(arrFilZona); 
                    const arrRowsfilter = infoRec.filter(value=> ZonasArr.includes(value.Zona?.toString()));
                    setRows(arrRowsfilter);
                    setBackupsRow(arrRowsfilter);
                }
                const dataUser = await fetch('/api/users');
                const infoUser = await dataUser.json();
                const arrMails = infoUser.map(elUser=> elUser.Mail);
                setRemitentesAll(arrMails);
                setTimeout(()=>{
                    setCharging(false);
                },500); 
            };
            
            handleUseEffect();

        },[]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(isContinuoPdf){
                setContinuoPdf(false);
                setReadyPdf(true);
            }
        },[isContinuoPdf]); // eslint-disable-line react-hooks/exhaustive-deps

        useEffect(()=>{
            if(getContinuoUnSelect){
                setContinuoUnSelect(false);
                setRows(rows_);
            }
        },[getContinuoUnSelect, backupsRow, rows_]);
        
        const handleClickMenu = (event) => { setOpenMenuColumn(event.currentTarget); };

        const handleClickMenuFixed = (event) => { setOpenMenuColumnFixed(event.currentTarget);};

        const handleClickMenuFilter = (event) => {
            setOpenMenuFilter(true);
            setElementFilterShow(true);
        };

        const handleClickMenuDate = (event) => { setOpenMenuDate(event.currentTarget);};

        const handleClickMenuPdf = (event) => { setOpenMenuPdf(event.currentTarget);};

        const handleClickMenuExcel = (event) => {setOpenMenuExcel(event.currentTarget);};

        const handleCloseMenu = () => {setOpenMenuColumn(null)};

        const handleCloseMenuFixed = () => { setOpenMenuColumnFixed(null) };

        const handleCloseMenuFilter = () => {
            setOpenMenuFilter(false);
            setElementFilterShow(false);
        };

        const handleCloseMenuDate = () => { setOpenMenuDate(null) };

        const handleCloseMenuPdf = ()=> { setOpenMenuPdf(null) };

        const handleCloseMenuExcel = ()=> { setOpenMenuExcel(null) };

        const handleRequestSort = useCallback((event, property) => {
            const isAsc = orderBy === property && order === 'asc';
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(property);
        },[order, orderBy])
            
        const handleChangePage = (event, newPage) => { setPage(newPage) };
        
        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };
    
        const handleChangeSwitch = (e)=>{
            const arrMap = headersColumn.map(value=>{
                if(value.id === e.target.name){
                    let objeto = {...value};
                    objeto.show = e.target.checked;
                    return objeto;
                }else{
                    return value;
                }
            });
            setHeadersColumn(arrMap);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(arrMap))
        };
        
        const ElementMenu = headersColumn.map((value,index)=>{
            return(
                <MenuItem key={`ElementMenu-${index}`}>
                    <FormControlLabel
                        control={
                        <Switch
                            checked={value.show}
                            onChange={handleChangeSwitch}
                            name={value.id}
                            color="primary"
                        />
                        }
                        label={value.label}
                    />
                </MenuItem>
            )
            
        });

        const handleChangeSwitchFixed = (e)=>{
            const arrMap = headersColumn.map(value=>{
                if(value.id === e.target.name){
                    let objeto = {...value};
                    objeto.fixed = e.target.checked;
                    return objeto;
                }else{
                    return value;
                }
            });
            setHeadersColumn(arrMap);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(arrMap))
            setSavingHeaders(true);
            setOpenMenuColumnFixed(false)
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000)
        };

        const ElementMenuFixed = headersColumn.map((value,index)=>( 
                <MenuItem key={`ElementMenuFixed-${index}`}>
                    <FormControlLabel
                        control={
                        <Switch
                            checked={value.fixed}
                            onChange={handleChangeSwitchFixed}
                            name={value.id}
                            color="primary"
                        />
                        }
                        label={value.label}
                    />
                </MenuItem>
        ));

        const HandleAddInformacionFilter = useCallback((objeto)=>{
            const arrF = arrFiltrado.map((value,index)=> {
                if(objeto.numero === index){
                    return objeto
                }else{
                    return value
                }
            })
            setArrFiltrado(arrF);
        },[arrFiltrado]);

        const HandleDeleteFilter = useCallback((infElement)=>{ 
            const arrF = arrFiltrado.filter((value,index)=> infElement !== index);
            setArrFiltrado(arrF);
        },[arrFiltrado]);

        const HandleAddFilter = useCallback(()=>{
            const cant = arrFiltrado.length;
            setArrFiltrado([...arrFiltrado, {numero:cant, valueElement:'', idElement:'', labelElement:'', selectElement:'O'} ]);
        },[arrFiltrado]);

        const ElementMenuFilter = arrFiltrado.map((value,index)=>
            <FiltradoEl 
                key={`filterElement-${index}`} 
                index={index} 
                info={value} 
                HandleAddFilter={HandleAddFilter} 
                HandleDeleteFilter={HandleDeleteFilter}
                HandleAddInformacionFilter={HandleAddInformacionFilter}
                headersColumn={headersColumn}
        />);

        const HandleProcessFilterElement = ()=>{
            console.log(arrFiltrado);
            if(isFilterNow){
                console.log('isFilterNow');
                let dataNow = [ ];
                arrFiltrado.forEach((value,index)=>{
                    if(index === 0){
                        if(value.type === 'number'){
                            backupsRow.forEach((value2)=>{
                                if(parseInt(value2[value.idElement]).includes(parseInt(value.valorElement))) dataNow.push(value2);
                            });
                        }else if(value.type === 'text'){
                            backupsRow.forEach((value2)=>{
                                if(value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase())) dataNow.push(value2);
                            });
                        }else{
                            backupsRow.forEach((value2)=>{
                                if(value2[value.idElement].toString() === value.valorElement.toString())  dataNow.push(value2);
                            });
                        }
                    }else{
                        if(value.type === 'number'){
                            if(value.selectElement === 'O'){
                                backupsRow.forEach((value2)=>{
                                    if(parseInt(value2[value.idElement]).includes(parseInt(value.valorElement))) dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    parseInt(value2[value.idElement]).includes(parseInt(value.valorElement))
                                );
                            }
                        }else if(value.type === 'text'){
                            if(value.selectElement === 'O'){
                                backupsRow.forEach((value2)=>{
                                    if(value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase())) dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase())
                                );
                            }          
                        }else{
                            if(value.selectElement === 'O'){
                                backupsRow.forEach((value2)=>{
                                    if(value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase())  dataNow.push(value2);
                                });
                            }else{
                                dataNow = dataNow.filter((value2)=>
                                    value2[value.idElement].toString() === value.valorElement.toString()
                                );
                            }
                                
                        }
                    }
                }); 
                let hash = {};
                dataNow = dataNow.filter(o => hash[o._id] ? false : hash[o._id] = true);
                setRows(dataNow);
                setRowsFilter(dataNow);
            }else{
                console.log('!isFilterNow');
                if(arrFiltrado[0].valorElement === ''){
                    setOpenMenuFilter(false);
                    setTimeout(()=>{
                        Swal.fire({
                            title:'NO HAY ELEMENTOS QUE FILTRAR',
                            toast:true,
                            confirmButtonColor:'#0E3B5F',
                        });
                    },200);
                    
                }else{
                    let dataNow = [ ];
                    arrFiltrado.forEach((value,index)=>{
                        if(index === 0){
                            console.log('index0');
                            if(value.type === 'number'){
                                backupsRow.forEach((value2)=>{
                                    if(parseInt(value2[value.idElement]).includes(parseInt(value.valorElement))) dataNow.push(value2);
                                });
                            }else if(value.type === 'text'){
                                backupsRow.forEach((value2)=>{
                                    if(value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase())) dataNow.push(value2);
                                });
                            }else{
                                backupsRow.forEach((value2)=>{
                                    if(value2[value.idElement].toString() === value.valorElement.toString())  dataNow.push(value2);
                                });
                            }
                        }else{
                            console.log('!index0');
                            if(value.type === 'number'){
                                if(value.selectElement === 'O'){
                                    backupsRow.forEach((value2)=>{
                                        if(parseInt(value2[value.idElement]).includes(parseInt(value.valorElement))) dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        parseInt(value2[value.idElement]).includes(parseInt(value.valorElement))
                                    );
                                }
                            }else if(value.idElement === 'text'){
                                if(value.selectElement === 'O'){
                                    backupsRow.forEach((value2)=>{
                                        if(value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase())) dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement].toString().toLowerCase().includes(value.valorElement.toString().toLowerCase())
                                    );
                                } 
                            }else{
                                if(value.selectElement === 'O'){
                                    backupsRow.forEach((value2)=>{
                                        if(value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase())  dataNow.push(value2);
                                    });
                                }else{
                                    dataNow = dataNow.filter((value2)=>
                                        value2[value.idElement].toString().toLowerCase() === value.valorElement.toString().toLowerCase()
                                    );
                                }  
                            }
                        }
                    }); 
                    let hash = {};
                    dataNow = dataNow.filter(o => hash[o._id] ? false : hash[o._id] = true);
                    setFilterNow(true);
                    setRows(dataNow);
                    setRowsFilter(dataNow);
                }
            }
        };

        const HandleResetFilter = ()=>{
            setElementFilterShow(false);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}])
            setFilterNow(false);
            if(isFilterDate){
                setRows(rowsFilterDate);
            }else{
                setRows(backupsRow);
            }
            setTimeout(()=>{
                setElementFilterShow(true);
            },1000)
        };

        const HandleMenuDate = (e)=>{ setElementDate({...elementDate, [e.target.id]:e.target.value })};

        const HandleClearDate = ()=>{
            setElementDate({});
            setOpenMenuDate(null);
            setFilterDate(false);
        };

        const HandleProcessFilterDate = ()=>{
            if(elementDate.Inicio === '' || elementDate.Final === ''){
                if(elementDate.Inicio === ''){
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'FECHA DE INICIO REQUERIDA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }else{
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'FECHA DE FINAL REQUERIDA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }
            }else{
                const resultInicio = elementDate.Inicio.split("-").map((value,index)=>(index === 1 ? parseInt(value) * 30 : parseInt(value))).reduce((a,b)=> a + b, 0);
                const resultFinal = elementDate.Final.split("-").map((value,index)=>(index === 1 ? parseInt(value) * 30 : parseInt(value))).reduce((a,b)=> a + b, 0);
                if(elementDate.idElement === ''){
                    setOpenMenuDate(null);
                    Swal.fire({
                        title:'DEBE SELECCIONAR UNA FILA',
                        toast:true,
                        confirmButtonColor:'#0E3B5F',
                    });
                }else{ 
                    if(resultInicio > resultFinal){ 
                        setOpenMenuDate(null);
                        Swal.fire({
                            title:'FECHA DE INICIO DEBE SER MENOR A LA FECHA FINAL',
                            toast:true,
                            confirmButtonColor:'#0E3B5F',
                            width:'450px'
                        });
                    }else{
                        const arrFil = [];
                        backupsRow.forEach((value)=>{
                            const dataEl = value[elementDate.idElement];
                            if(dataEl !== undefined){                         
                                const valFecha = dataEl.split("-").map((value,index)=>(index === 1 ? parseInt(value) * 30 : parseInt(value))).reduce((a,b)=>parseInt(a) + parseInt(b));
                                if(valFecha >= resultInicio){
                                    if(valFecha <= resultFinal) arrFil.push(value);
                                } 
                            }
                        })
                        if(arrFil.length === 0){
                            alert('NO HAY ELEMENTOS QUE VISUALIZAR')
                        }else{
                            setFilterDate(true);
                            setOpenMenuDate(null);
                            setRows(arrFil);
                            setRowsFilterDate(arrFil);
                        }
                        
                    }
                }
            }
            
        };

        const HandleResetFilterDate = ()=>{
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setFilterDate(false);
            if(isFilterNow){
                setRows(rowsFilter)
            }else{
                setRows(backupsRow);
            }    
        };

        const HandleAutoComplete = (e, value)=>{
            if(value === '' || value === null){
                setElementDate({...elementDate, idElement:'', labelElement:'', valorElement:''});
            }else{ 
                const arrFilHeaders = headersColumn.filter(value2=> value2.label === value);
                if(arrFilHeaders.length > 0){
                    setElementDate({...elementDate, idElement:arrFilHeaders[0].id.toString(), labelElement:value});
                }  
            }
            
        };

        const handleClickRow = useCallback((statusRow, row)=>{
            if(statusRow){
                setSelectionArr(arr=> { 
                    const el = [...arr];
                    el.push(row);
                    return el
                });
            }else{
                setSelectionArr(arr=> arr.filter(value=> value._id !== row._id));
            }
        },[]);

        const HandleExportSelectPdf = ()=>{
            if(selectionArr.length === 0){
                setOpenMenuPdf(null);
                Swal.fire({
                    title:'NO HAY ELEMENTOS A EXPORTAR',
                    toast:true,
                    confirmButtonColor:'#0E3B5F',
                });
            }else{
                if(isReadyPdf){
                    const FiltHeaders = headersColumn.filter(value=> value.show);
                    const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                    const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                    setArrHeadersPdf(FiltHeaders2);
                    setReadyPdf(false);
                    setSelectPdf(true);
                    setContinuoPdf(true);
                }else{
                    const FiltHeaders = headersColumn.filter(value=> value.show);
                    const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                    const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                    setArrHeadersPdf(FiltHeaders2);
                    setSelectPdf(true);
                    setContinuoPdf(true);
                }
                
            }
        };

        const HandleExportAllPdf = ()=>{
            if(isReadyPdf){
                const FiltHeaders = headersColumn.filter(value=> value.show);
                const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                setArrHeadersPdf(FiltHeaders2);
                setReadyPdf(false);
                setSelectPdf(false);
                setContinuoPdf(true);
            }else{
                const FiltHeaders = headersColumn.filter(value=> value.show);
                const FiltHeaders1 = FiltHeaders.filter(value=> value.id !== 'Action');
                const FiltHeaders2 = FiltHeaders1.filter(value=> value.id !== 'Fotos');
                setArrHeadersPdf(FiltHeaders2);
                setSelectPdf(false);
                setContinuoPdf(true);
                
            }
        };

        const HandleClickPdf = useCallback(()=>{
            setTimeout(()=>{
                setReadyPdf(false);
            },2000)
        },[]);

        const handleCloseSelectPersonsMail = ()=>{ setOpenSelectPersonsMail(false);};

        const HandleRemitentes = (e, value)=>{ setRemitentes(value) };

        const HandleSelectPersonsMail = ()=>{
            if(selectionArr.length > 0){
                setOpenSelectPersonsMail(true);
            }else{
                enqueueSnackbar('SELECCIONE UNA FILA POR LO MENOS', {variant:'info'});
            }
        };

        const HandleSendCorreos = ()=>{
            fetch('/SendMailsRows',{ 
                method: 'POST',
                body: JSON.stringify({Elementos:selectionArr, headersColumn, Remitentes}),
                headers:{'Content-Type':'application/json'}
            })
            .then(response=> response.json())
            .then(result =>{
                setOpenSelectPersonsMail(false);
                enqueueSnackbar('Correos Enviados', {variant:'success'});
            });
        };
        
        const HandleProcessHeaders = useCallback((dataHeadersStyle)=>{
            const headersResultStyles = headersColumn.map(value=>{
                if(value.id === dataHeadersStyle.id){
                    return dataHeadersStyle;
                }else{
                    return value;
                }
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles))
            setSavingHeaders(true);
            setOpenMenuStyles(false)
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        },[headersColumn]);

        const ElementMenuStyles = headersColumn.map((value,index)=>( 
            <Grid item key={`ElementMenuStyles_${index}`} xl={12} lg={12} md={12} sm={12} xs={12} >
                <RowHeadersStyle rowInfo={value} HandleProcessHeaders={HandleProcessHeaders} widthWin={widthWin}/>
            </Grid>
                
        ));

        const handleOpenMenuStyles = ()=>{ setOpenMenuStyles(true) };

        const handleCloseMenuStyles = ()=>{ setOpenMenuStyles(false) };

        const handleHeadersPosicion = (e)=>{
            const idEl = e.target.id.split('_')[0];
            const arr =  headersColumn.map(value=>{
                if(value.id.toString() === idEl.toString()){
                    const objeto = {...value};
                    objeto.num = e.target.value;
                    return objeto;
                }else{
                    return value;
                }
            })
            setHeadersColumn(arr);
        };

        const ElementMenuPosicion = headersColumn.map((value,index)=>( 
            <Grid item md={4} xs={6} style={{width:100}} key={`ElementFixed_${index}`}>
                <TextField 
                    id={`${value.id}_${value.num}`}
                    name={'num'}
                    value={value.num ||''}
                    onChange={handleHeadersPosicion}
                    fullWidth
                    margin='dense'
                    variant='outlined'
                    label={value.label}
                />
            </Grid>
        ));

        const handleClickMenuPosicion = () => { setOpenMenuPosicion(true)};
        
        const handleCloseMenuPosicion = ()=> { setOpenMenuPosicion(false) };

        const handleResetPosicion = ()=>{
            const headersResultStyles = [];
            headersColumn.forEach(value=>{
                headCellsColumn.forEach(value2=>{
                    if(value.id === value2.id){
                        const objeto = {...value};
                        objeto.num = value2.num;
                        headersResultStyles.push(objeto);
                    }
                })
            })
            headersResultStyles.sort(function (a, b) {
                if (a.num > b.num) {
                  return 1;
                }
                if (a.num < b.num) {
                  return -1;
                }
                return 0;
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles));
            setOpenMenuPosicion(false);
            setSavingHeaders(true);
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        };

        const handleProcessPosicion = ()=>{
            const headersResultStyles = headersColumn;
            headersResultStyles.sort(function (a, b) {
                if (a.num > b.num) {
                  return 1;
                }
                if (a.num < b.num) {
                  return -1;
                }
                return 0;
            });
            setHeadersColumn(headersResultStyles);
            window.localStorage.setItem(variablesObject.nameLocalStorage, JSON.stringify(headersResultStyles))
            setSavingHeaders(true);
            setTimeout(()=>{
                setSavingHeaders(false);
            },2000);
        };

        const handleDeleteRow = useCallback((idEl)=>{
            setBackupsRow((inf)=>inf.filter(el=>el._id !== idEl));
            setRows((inf)=>inf.filter(el=>el._id !== idEl));
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setFilterDate(false);
            setElementFilterShow(false);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}])
            setFilterNow(false);
        },[ ]);

        const handleClearZona = ()=>{
            setZonaSelected('');
            setZonaSelectedObject({});
            setSelectedZona(false);
            setDataClientes([]);
            const filterRec = backupsRow.filter(elRecibo=>elRecibo.isPromise);
            setRows(filterRec);
            setPage(0);
            //handleReset();
        };
    
        const handleSelectZona = (valZ)=>{
            setProcesing(true);
            setPage(0);
            fetch('/api/clientes/byEmpresa&Zona',
                { 
                    method:'POST', 
                    body: JSON.stringify({Empresa:authTokens.Empresa, Zona:valZ}), 
                    headers:{'Content-Type': 'application/json'}
                }) 
            .then(response=> response.json())
            .then(result =>{
                if(result.Status){
                    enqueueSnackbar(result.Status, {variant:'error'})
                }else{
                    setZonaSelected(valZ);
                    const resultClientes = result.filter(value=>value.Status === 'Activo');
                    const arrClientes = [];
                    for(const x in resultClientes){
                        const objeto = {...resultClientes[x]};
                        const arrFiltrado = resultClientes[x].Servicios.filter(value=>value.ZonaService === valZ);
                        if(arrFiltrado.length > 0){
                            objeto.Servicios = arrFiltrado;
                            arrClientes.push(objeto);
                        }
                    }
                    setRows(()=> backupsRow.filter(elRow=>elRow.Zona === valZ));
                    setSelectedZona(true);
                    setDataClientes(arrClientes);
                    setProcesing(false);
                    setZonaSelectedObject(dataZona.find(value=> value.Zona.toString() === valZ.toString()));
                }
            });
                
        };

        const handleFormularioNombres = (e, value)=>{ 
            if(value === null){
                setFormulario({...formulario, CI:'', Nombres:'', idForMikrotik:'', Servicios:[]})
            }else{
                const infoCliente = dataClientes.filter(elCliente =>elCliente.Nombres === value)[0];
                setFormulario({...formulario, Nombres:value, CI:infoCliente.CI, Servicios:infoCliente.Servicios})
            }
        };

        const handleFormularioCI = (e, value)=>{ 
            if(value === null){
                setFormulario({...formulario, CI:'', Nombres:'', idForMikrotik:'', Servicios:[]})
            }else{
                const infoCliente = dataClientes.filter(elCliente =>elCliente.CI === value)[0];
                setFormulario({...formulario, CI:value, Nombres:infoCliente.Nombres, Servicios:infoCliente.Servicios})
            }
        };

        const handleFormularioReferencia =  async ( e, value, reason)=>{
            if(reason === 'clear'){
                setReciboSelected({
                    fechaCortePromesa:(()=>{
                    const laZona="America/Guayaquil";
                    const laFecha = moment().tz(laZona).format();
                    return laFecha.split('T')[0]
                    })()
                })
                setReciboPendiente('');
                setArrRecibosPendientes([]);
                setFormulario({...formulario, 
                    idForMikrotik:'',
                    fechaCortePromesa:(()=>{
                    const laZona="America/Guayaquil";
                    const laFecha = moment().tz(laZona).format();
                    return laFecha.split('T')[0]
                    })()
                });
                setSelectRecibo(false);
            }else if(reason === 'select-option'){
                setFormulario({...formulario, idForMikrotik:value});
                const getReciepts_ = await fetch(`/api/RecibosPendientesbyidForMikrotik/${value}`);
                const jsnReciepts_ = await getReciepts_.json();
                if(jsnReciepts_.length > 0){
                    setArrRecibosPendientes(jsnReciepts_);
                }else{
                    enqueueSnackbar('NO HAY RECIBOS PENDIENTES, SELECCIONE OTRO CLIENTE', {variant:'info'})
                }
                
            }
            
        };

        const handleSelectReciboPendiente = (e, value, reason)=>{
            if(reason === 'clear'){
                setReciboPendiente('');
                setReciboSelected({
                    fechaCortePromesa:(()=>{
                    const laZona="America/Guayaquil";
                    const laFecha = moment().tz(laZona).format();
                    return laFecha.split('T')[0]
                    })()
                })
                setSelectRecibo(false);
            }else if(reason === 'select-option'){
                const reciboSel = arrRecibosPendientes.filter(elRecibo=>elRecibo.MesServicio === value)[0];
                const objeto_ = {...reciboSel};
                objeto_.fechaCortePromesa = (()=>{
                    const laZona="America/Guayaquil";
                    const laFecha = moment().tz(laZona).format();
                    return laFecha.split('T')[0]
                    })()
                setReciboSelected(objeto_)
                setReciboPendiente(value);
                setSelectRecibo(true);
            }
        };

        const handleOpenFormulario = ()=>{ setOpenFormulario(true) };

        const handleCloseFormulario = ()=>{ setOpenFormulario(false) };
        
        const handleUpdateRecibo = ()=>{
            if(reciboSelected.fechaCortePromesa === '' || !reciboSelected.fechaCortePromesa){
                alert('SELECCIONE UNA FECHA')
            }else{
                setOpenConfirmacion(true);
            }
        };

        const handleConfirmUpdate = ()=>{
            setContinuoPromise(true);
            const objeto = {...reciboSelected};
            const objeto2 = {};
            objeto2.Plan = reciboSelected.Plan;
            objeto2.idForMikrotik = reciboSelected.idForMikrotik;
            objeto2.idFromMikrotik = reciboSelected.idFromMikrotik;
            objeto2.TipoServicioMk = reciboSelected.TipoServicioMk;
            objeto.InfoZona = zonaSelectedObject;
            objeto.isPromise = true;
            objeto.serviceSelected = objeto2;
            fetch('/api/PromesasRecibos',{ method:'PUT', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
            .then(response=> response.json())
            .then(result =>{
                if(result.status){
                    setContinuoPromise(false);
                    enqueueSnackbar(result.Status, {variant:'error'})
                }else{
                    if(reciboSelected.isPromise){
                        const arrNew = backupsRow.map(el=> el._id === result.dataMerc._id ? result.dataMerc : el);
                        setBackupsRow(arrNew);
                        setRows(arrNew);
                    }else{
                        const arr = [...backupsRow];
                        arr.unshift(result.dataMerc);
                        setBackupsRow(arr);
                        setRows(arr);
                    }
                    setReciboSelected({
                        fechaCortePromesa:(()=>{
                        const laZona="America/Guayaquil";
                        const laFecha = moment().tz(laZona).format();
                        return laFecha;
                        })()
                    });
                    setContinuoPromise(false);
                    setReciboPendiente('');
                    setArrRecibosPendientes([]);
                    setFormulario({...formulario, CI:'', Nombres:'', idForMikrotik:'', Servicios:[]})
                    setSelectRecibo(false);
                    setOpenConfirmacion(false);
                    setOpenFormulario(false);
                    Swal.fire({
                        title: result.message,
                        icon:'success',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596'
                    })
                }
                
            });
        };

        const handleCloseConfirmacion = () =>{
            setOpenConfirmacion(false);
        };

        const handleFormularioDate = ( date, dateString)=>{
            setReciboSelected({...reciboSelected, fechaCortePromesa:dateString})
        };

        const handleClickMenuBusqueda = (event) => {
            setOpenMenuBusqueda(event.currentTarget);};

        const handleCloseMenuBusqueda = () => { setOpenMenuBusqueda(null) };

        const handleShowBusqueda = ()=>{
            setShowBusqueda(el=>{
                if(el) {
                    setRows(backupsRow);
                    setSearch('');
                }
                return !el
            });
        };

        const handleSearch = ({target})=>{
            setSearch(target.value);
            if(target.value === ''){
                setRows(zonaSelected === '' ? backupsRow: backupsRow.filter(el=> el.Zona === zonaSelected));
            }else{
                setRows(backupsRow.filter(el=>el[getOptionSearch]?.toString().toLowerCase().includes(target.value.toLowerCase())));
            }
        };

        const handleSelectionAll = ()=>{
            setSelectionArr(rows);
            setRows_(rows);
            setRows([]);
            setContinuoUnSelect(true);
        };

        const handleUnSelect = ()=>{
            setSelectionArr([]);
            setRows([]);
            setSelectionArr([]);
            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
            setFilterNow(false);
            setFilterDate(false);
            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''});
            setContinuoUnSelect(true);
        };

        const handleDeleteMultiple = ()=>{
            Swal.fire({
                title:`DESEA ELIMINAR TODO(A)S ${variablesObject.title}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonColor:'#005596'
            }).then((result) => {
                if (result.isConfirmed){
                    const objeto = {};
                    objeto.selectionArr = [...selectionArr];
                    fetch(variablesObject.apiMultiples,{ method:'DELETE', body: JSON.stringify(objeto), headers:{'Content-Type': 'application/json'}}) 
                    .then(response=> response.json())
                    .then(result =>{
                        if(result.message){
                            const arrNew = selectionArr.map(el=> el._id);
                            const arrFiltrado_ = rows.filter(el=> !arrNew.includes(el._id));
                            setRows(arrFiltrado_);
                            setBackupsRow(arrFiltrado_);
                            setSelectionArr([]);
                            setArrFiltrado([{idElement:'', valorElement:'', numero:0, labelElement:'', selectElement:'', type:''}]);
                            setFilterNow(false);
                            setFilterDate(false);
                            setElementDate({ idElement:'', labelElement:'', Inicio:'', Final:''})
                            enqueueSnackbar(result.message, {variant:'success'});
                        }else{
                            enqueueSnackbar(result.status, {variant:'error'});
                        }
                    })
                }
            })
        };

        return(
            <React.Fragment>
                <Dialog
                    open={openMenuFilter}
                    onClose={handleCloseMenuFilter}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Grid container justifyContent='center' spacing={1}>
                            { isElementFilterShow ? ElementMenuFilter
                            : <FacebookCircularProgress size={25} style={{marginTop:5}}/>}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='flex-start' spacing={2} style={{padding:15}}>
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='CERRAR' placement='top'>
                                            <Fab color="default" size='small' onClick={handleCloseMenuFilter} >
                                                <ClearIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='RESETEAR' placement='top'>
                                            <Fab color="secondary" size='small' onClick={HandleResetFilter} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='PROCESAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={HandleProcessFilterElement}>
                                                <NavigateNextIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="default" fullWidth onClick={handleCloseMenuFilter} endIcon={<ClearIcon/>}>
                                            Cerrar
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="secondary" fullWidth onClick={HandleResetFilter} endIcon={<AutorenewIcon/>}>
                                            Resetear
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="primary" fullWidth onClick={HandleProcessFilterElement} endIcon={<NavigateNextIcon/>}>
                                            Procesar
                                        </Button>
                                    </Grid>
                                </Fragment>
                            }
                        </Grid>
                        
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openMenuStyles}
                    onClose={handleCloseMenuStyles}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            {ElementMenuStyles}
                        </Grid>
                        
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={openMenuPosicion}
                    onClose={handleCloseMenuPosicion}
                    fullWidth
                    maxWidth={'md'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                >
                    <DialogContent>
                        <Grid container spacing={2}>
                            {ElementMenuPosicion}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='flex-start' spacing={2} style={{padding:15}}>
                            {
                                widthWin === 'xs' || widthWin === 'sm' ?
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='CERRAR' placement='top'>
                                            <Fab color="default" size='small' onClick={handleCloseMenuPosicion} >
                                                <ClearIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='RESETEAR' placement='top'>
                                            <Fab color="secondary" size='small' onClick={handleResetPosicion} >
                                                <AutorenewIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={3} xs={3}>
                                        <Tooltip  title='PROCESAR' placement='top'>
                                            <Fab color="primary" size='small' onClick={handleProcessPosicion}>
                                                <NavigateNextIcon />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                </Fragment>:
                                <Fragment>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="default" fullWidth onClick={handleCloseMenuPosicion} endIcon={<ClearIcon/>}>
                                            Cerrar
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="secondary" fullWidth onClick={handleResetPosicion} endIcon={<AutorenewIcon/>}>
                                            Resetear
                                        </Button>
                                    </Grid>
                                    <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                        <Button variant='contained' color="primary" fullWidth onClick={handleProcessPosicion} endIcon={<NavigateNextIcon/>}>
                                            Procesar
                                        </Button>
                                    </Grid>
                                </Fragment>
                            }
                        </Grid>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openSelectPersonsMail}
                    onClose={handleCloseSelectPersonsMail}
                    fullWidth
                    maxWidth={'sm'}
                    aria-labelledby="draggable-dialog-title"
                    style={{padding:0}}
                    TransitionComponent={Transition}
                    disableEscapeKeyDown
                >
                    <DialogContent>
                        <Autocomplete
                            id="Remitentes"
                            freeSolo
                            options={RemitentesAll}
                            value={Remitentes || ''}
                            onChange={HandleRemitentes}
                            multiple
                            renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="standard"
                                  label="Remitentes"
                                />
                              )}
                        /> 
                    </DialogContent>
                    <DialogActions>
                        <Grid container justifyContent='center' spacing={2}>
                                <Grid item md={4} xs={6}>
                                    <Button variant='contained' fullWidth onClick={handleCloseSelectPersonsMail} color="default" style={{height:40}}>
                                        CANCELAR
                                    </Button>
                                </Grid>
                                <Grid item md={4} xs={6}>
                                    <Button variant='contained' fullWidth onClick={HandleSendCorreos} color="primary" style={{height:40}}>
                                        ENVIAR
                                    </Button> 
                                </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>
                <ModalAntd 
                    title="PROMESA" 
                    visible={openFormulario} 
                    onCancel={handleCloseFormulario} 
                    onOk={handleUpdateRecibo} 
                    okText='CONTINUAR'
                    cancelText='CANCELAR'
                    centered
                    closable
                    okButtonProps={{disabled:isContinuoPromise, loading:isContinuoPromise}}
                    >
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="Nombres"
                                    options={dataClientes.map(elCliente=>elCliente.Nombres).sort()}
                                    value={formulario.Nombres || ''}
                                    onChange={handleFormularioNombres}                 
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Nombres"
                                        />
                                    )}
                                /> 
                            </Grid> 
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="CI"
                                    options={dataClientes.map(elCliente=>elCliente.CI).sort()}
                                    value={formulario.CI || ''}
                                    onChange={handleFormularioCI}                 
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="CI"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="idForMikrotik"
                                    options={formulario.Servicios.map(elServicio=>elServicio.idForMikrotik)}
                                    value={formulario.idForMikrotik || ''}
                                    onChange={handleFormularioReferencia}                 
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="ID"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    id="ReciboPendiente"
                                    options={arrRecibosPendientes.map(elRecibo=>elRecibo.MesServicio)}
                                    value={reciboPendiente || ''}
                                    onChange={handleSelectReciboPendiente}                 
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="standard"
                                        label="Recibo"
                                        />
                                    )}
                                /> 
                            </Grid>
                            <Grid item xs={12}>
                                <DatePicker 
                                    allowClear={false}
                                    disabled={!isSelectRecibo}
                                    mode='date'
                                    onChange={handleFormularioDate} 
                                    placeholder='Fecha Corte'
                                    placement='topRight'
                                    size='large'
                                    style={{width:'100%', marginTop:5}}
                                    value={moment(reciboSelected.fechaCortePromesa, 'YYYY-MM-DD')}
                                />
                            </Grid>
                        </Grid>
                </ModalAntd> 
                <ModalAntd 
                    title="DESEA CREAR ESTA PROMESA?" 
                    visible={openConfirmacion} 
                    onCancel={handleCloseConfirmacion} 
                    onOk={handleConfirmUpdate} 
                    okText='SI'
                    cancelText='NO'
                    centered
                    closable
                    okButtonProps={{disabled:isContinuoPromise, loading:isContinuoPromise}}
                    >
                        
                </ModalAntd> 
                <Grid container style={{width:'100%', padding:5}} justifyContent='center' spacing={1} alignItems='flex-start'>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >
                        <Grid container spacing={1} justifyContent='space-between' alignItems='center' style={{padding:1}}>
                            {
                                    widthWin === 'xs' ||  widthWin === 'sm'?
                                    <React.Fragment>
                                    <Grid item  md={3} sm={10} xs={12} style={{ padding:0 }}>
                                        {   isShowBusqueda ? 
                                            <Grid 
                                                container 
                                                justifyContent='space-around' 
                                                alignItems='center' 
                                                spacing={0}
                                            >
                                                <Grid item xs={9}>
                                                    <TextField 
                                                        id='SearchOptions'
                                                        fullWidth
                                                        label='Busqueda'
                                                        onChange={handleSearch}  
                                                        placeholder={ getOptionSearch || 'Busqueda' }
                                                        size='small'
                                                        value={ getSearch || ''}
                                                        variant='outlined'
                                                        margin='dense'
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                                        <span>
                                                        <IconButton 
                                                            color='primary' 
                                                            onClick={handleClickMenuBusqueda}  
                                                            aria-controls="menu-column-busqueda" 
                                                            aria-haspopup="true" 
                                                            size='small'
                                                        >                            
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Menu
                                                        id="menu-column-busqueda"
                                                        anchorEl={openMenuBusqueda}
                                                        keepMounted
                                                        open={Boolean(openMenuBusqueda)}
                                                        onClose={handleCloseMenuBusqueda}
                                                    >
                                                        {
                                                            headersColumn.map((el, index)=>
                                                                <MenuItem 
                                                                    key={`${el.id}_${index}_`} 
                                                                    style={{width:'100%'}}
                                                                    onClick={()=>{
                                                                        setOptionSearch(el.id);
                                                                        setOpenMenuBusqueda(null)
                                                                    }}
                                                                >
                                                                    {el.label}
                                                                </MenuItem>
                                                            )
                                                        }
                                                    </Menu>   
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='OCULTAR BUSQUEDA' placement='top'>
                                                        <span>
                                                            <IconButton 
                                                                aria-controls="menu-column-busqueda" 
                                                                aria-haspopup="true" 
                                                                color='primary'
                                                                style={{ background:'dodgerblue', color:'#fff' }}
                                                                onClick={handleShowBusqueda}  
                                                                size='small'
                                                            >                            
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>:
                                            <Grid
                                                alignItems='center' 
                                                container 
                                                justifyContent='center' 
                                                spacing={2} 
                                                style={{minHeight:68, height:65}}
                                            >
                                                <Grid item>
                                                    <Chip label={variablesObject.title} color='secondary' />
                                                </Grid>
                                                <Grid item>
                                                    <IconButton 
                                                        aria-controls="menu-column-busqueda" 
                                                        aria-haspopup="true" 
                                                        color='primary'
                                                        onClick={handleShowBusqueda}  
                                                        size='small'
                                                    >                            
                                                        <SearchIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                    <Grid item xs={10} >
                                        <Autocomplete
                                            id="Zona"
                                            options={dataZona.map(value=>value.Zona)}
                                            value={zonaSelected || ''}                              
                                            renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                            onChange={(e,value, reason)=>{
                                                if(reason ===  'clear'){
                                                    handleClearZona()
                                                }else{
                                                    handleSelectZona(value);
                                                }
                                            }}  
                                        />
                                    </Grid>
                                    <Grid item xs={2} style={{display:'grid', placeContent:'center'}}>
                                        <Tooltip title='ADD PROMISE' placement='top'>
                                            <span>
                                            <IconButton 
                                                color='primary' 
                                                disabled={!isSelectedZona}
                                                onClick={handleOpenFormulario} 
                                                size='small' 
                                                style={{ background:isSelectedZona?'dodgerblue' : 'gray', color:'#fff' }} 
                                            >
                                                <PlusOneIcon />
                                            </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Grid>
                                    </React.Fragment>:
                                    <React.Fragment>
                                        <Grid item  lg={3} md={4} sm={10} xs={12}>
                                            {   isShowBusqueda ? 
                                                <Grid container justifyContent='space-between' alignItems='center' spacing={0}>
                                                    <Grid item xs={9}>
                                                        <TextField 
                                                            id='SearchOptions'
                                                            fullWidth
                                                            label='Busqueda'
                                                            onChange={handleSearch}  
                                                            placeholder={ getOptionSearch || '' }
                                                            size='small'
                                                            value={ getSearch || ''}
                                                            variant='outlined'
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <Tooltip title='OPCIONES DE BUSQUEDA' placement='top' >
                                                            <span>
                                                            <IconButton 
                                                                color='primary' 
                                                                onClick={handleClickMenuBusqueda}  
                                                                aria-controls="menu-column-busqueda" 
                                                                aria-haspopup="true" 
                                                                size='small'
                                                            >                            
                                                                <MoreVertIcon />
                                                            </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                        <Menu
                                                            id="menu-column-busqueda"
                                                            anchorEl={openMenuBusqueda}
                                                            keepMounted
                                                            open={Boolean(openMenuBusqueda)}
                                                            onClose={handleCloseMenuBusqueda}
                                                        >
                                                            {
                                                                headersColumn.map((el, index)=>
                                                                    <MenuItem 
                                                                        key={`${el.id}_${index}_`} 
                                                                        style={{width:'100%'}}
                                                                        onClick={()=>{
                                                                            setOptionSearch(el.id);
                                                                            setOpenMenuBusqueda(null)
                                                                        }}
                                                                    >
                                                                        {el.label}
                                                                    </MenuItem>
                                                                )
                                                            }
                                                        </Menu>   
                                                    </Grid>
                                                    <Grid item>
                                                        <Tooltip title='OCULTAR BUSQUEDA' placement='top'>
                                                            <span>
                                                                <IconButton 
                                                                    aria-controls="menu-column-busqueda" 
                                                                    aria-haspopup="true" 
                                                                    color='primary'
                                                                    style={{ background:'dodgerblue', color:'#fff' }}
                                                                    onClick={handleShowBusqueda}  
                                                                    size='small'
                                                                >                            
                                                                    <SearchIcon />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>:
                                                <Grid container justifyContent='center' alignItems='center' >
                                                    <Grid item>
                                                        <Chip label={variablesObject.title} color='secondary' />
                                                    </Grid>
                                                    <Grid item>
                                                        <Tooltip title='MOSTRAR BUSQUEDA' placement='top'>
                                                            <span>
                                                                <IconButton 
                                                                    aria-controls="menu-column-busqueda" 
                                                                    aria-haspopup="true" 
                                                                    color='primary'
                                                                    onClick={handleShowBusqueda}  
                                                                    size='small'
                                                                >                            
                                                                    <SearchIcon />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            }
                                        </Grid>
                                        <Grid item>
                                            <Grid 
                                                container
                                                spacing={1}
                                                justifyContent='flex-start'
                                                alignItems='center'
                                                style={{flexWrap:'no-wrap'}}
                                            >
                                                <Grid item >
                                                    <Tooltip title='VER' placement='top'>
                                                        <span>
                                                        <IconButton color='primary' onClick={handleClickMenu}  aria-controls="menu-column" aria-haspopup="true" style={{marginRight:2}}>                           
                                                            <VisibilityIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>         
                                                    <Menu
                                                        id="menu-column"
                                                        anchorEl={openMenuColumn}
                                                        keepMounted
                                                        open={Boolean(openMenuColumn)}
                                                        onClose={handleCloseMenu}
                                                        >
                                                        {ElementMenu}
                                                    </Menu>
                                                </Grid>
                                                <Grid item >
                                                    <Tooltip title='FIJAR' placement='top' >
                                                        <span>
                                                        <IconButton color='primary' onClick={handleClickMenuFixed}  aria-controls="menu-column-fixed" aria-haspopup="true" style={{marginRight:2}}>                     
                                                            <ViewWeekIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip> 
                                                    <Menu
                                                        id="menu-column-fixed"
                                                        anchorEl={openMenuColumnFixed}
                                                        keepMounted
                                                        open={Boolean(openMenuColumnFixed)}
                                                        onClose={handleCloseMenuFixed}
                                                        >
                                                        {ElementMenuFixed}
                                                    </Menu>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='FILTRAR' placement='top' >
                                                        <span>
                                                        <IconButton color={isFilterNow ? 'secondary' : 'default'} onClick={handleClickMenuFilter} style={{marginRight:2}}>                      
                                                            <FilterListIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='FECHAS' placement='top' >
                                                        <span>
                                                        <IconButton color={isFilterDate ? 'secondary' : 'default'} onClick={handleClickMenuDate}  aria-controls="menu-column-date" aria-haspopup="true" style={{marginRight:2}}>                            
                                                            <DateRangeIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Menu
                                                        id="menu-column-date"
                                                        anchorEl={openMenuDate}
                                                        keepMounted
                                                        open={Boolean(openMenuDate)}
                                                        onClose={handleCloseMenuDate}
                                                    >
                                                        <MenuItem key={'ElementMenuDate-Columna'} style={{width:'100%'}}>
                                                            <Autocomplete
                                                                id={'AutoComplete-ElementDate'}
                                                                options={headersColumn.filter(el=>el.type==='date')}
                                                                getOptionLabel={option => option.label }
                                                                renderInput={(params) => <TextField {...params} label="Columna" fullWidth variant="outlined" />}
                                                                inputValue={elementDate.labelElement || ''}
                                                                onInputChange={HandleAutoComplete}
                                                                size='small'
                                                                style={{width:'100%'}}
                                                            />
                                                        </MenuItem>
                                                        <MenuItem key={'ElementMenuDate-Inicio'}>
                                                            <TextField 
                                                                id='Inicio'
                                                                value={elementDate.Inicio || new Date()}
                                                                onChange={HandleMenuDate}
                                                                fullWidth
                                                                margin='dense'
                                                                type='date'
                                                                label='Inicio'
                                                                autoFocus
                                                            />
                                                        </MenuItem>
                                                        <MenuItem key={'ElementMenuDate-Final'}>
                                                            <TextField 
                                                                id='Final'
                                                                value={elementDate.Final ||  new Date()}
                                                                onChange={HandleMenuDate}
                                                                fullWidth
                                                                margin='dense'
                                                                type='date'
                                                                label='Final'
                                                                autoFocus
                                                            />
                                                        </MenuItem>
                                                        <MenuItem key={'ElementMenuDate-Process'}>
                                                            <Grid container justifyContent='center'>
                                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                                    <Fab color="default" size='small' onClick={HandleClearDate} >
                                                                        <ClearIcon />
                                                                    </Fab>
                                                                </Grid>
                                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                                    <Fab color="secondary" size='small' onClick={HandleResetFilterDate} >
                                                                        <AutorenewIcon />
                                                                    </Fab>
                                                                </Grid>
                                                                <Grid item xl={4} lg={4} md={4} sm={4} xs={4}>
                                                                    <Fab color="primary" size='small' onClick={HandleProcessFilterDate}>
                                                                        <NavigateNextIcon />
                                                                    </Fab>
                                                                </Grid>
                                                            </Grid>
                                                        </MenuItem>
                                                    </Menu>   
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='EXPORT PDF' placement='top'>
                                                        <span>
                                                        <IconButton aria-controls="menu-cpdf" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuPdf} color='primary'>                          
                                                            <PictureAsPdfIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>  
                                                    <Menu
                                                        id="menu-pdf"
                                                        anchorEl={openMenuPdf}
                                                        keepMounted
                                                        open={Boolean(openMenuPdf)}
                                                        onClose={handleCloseMenuPdf}
                                                    >
                                                        <MenuItem onClick={HandleExportSelectPdf} >
                                                            Export Select
                                                        </MenuItem>
                                                        <MenuItem onClick={HandleExportAllPdf} >
                                                            Export All
                                                        </MenuItem>
                                                        <MenuItem style={{display:'flex', justifyContent:'center'}}>
                                                            {
                                                                isReadyPdf ? <PdfElement data={isSelectPdf ? selectionArr : rows} headersColumn={arrHeadersPdf} HandleClickPdf={HandleClickPdf}/>
                                                                : '...'
                                                            }
                                                        </MenuItem>
                                                    </Menu>
                                                </Grid>
                                                <Grid item>         
                                                    <Tooltip title='EXPORT EXCEL' placement='top'>
                                                        <span>
                                                        <IconButton aria-controls="menu-excel" aria-haspopup="true" style={{marginRight:2}} onClick={handleClickMenuExcel} color='primary'>                           
                                                            <DescriptionIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Menu
                                                        id="menu-excel"
                                                        anchorEl={openMenuExcel}
                                                        keepMounted
                                                        open={Boolean(openMenuExcel)}
                                                        onClose={handleCloseMenuExcel}
                                                    >
                                                        <MenuItem >
                                                            {
                                                                selectionArr.length === 0 ? <span onClick={()=>{ setOpenMenuExcel(null);
                                                                    Swal.fire({
                                                                        title:'NO HAY ELEMENTOS A EXPORTAR',
                                                                        toast:true,
                                                                        confirmButtonColor:'#0E3B5F',
                                                                    });}}>Export Select</span>
                                                                :<ExcelComponent data={selectionArr} titulo={'Export Select'} headersColumn={headersColumn}/>
                                                            }
                                                        </MenuItem>
                                                        <MenuItem >
                                                            <ExcelComponent data={rows} titulo={'Export All'} headersColumn={headersColumn} />
                                                        </MenuItem>
                                                    </Menu>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title='CORREOS' placement='top'>
                                                        <span>
                                                        <IconButton color='primary' onClick={HandleSelectPersonsMail}  style={{marginRight:2}}>
                                                            <MarkunreadMailboxIcon/>
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                {
                                                    selectionArr.length === 0 &&
                                                    <React.Fragment>
                                                        <Grid item>
                                                            <Tooltip title='ESTILOS' placement='top'>
                                                                <span>
                                                                <IconButton style={{marginRight:2}} onClick={handleOpenMenuStyles} color='primary'>                           
                                                                    <BrushIcon />
                                                                </IconButton>
                                                                </span>
                                                            </Tooltip>  
                                                        </Grid>
                                                        <Grid item>
                                                            <Tooltip title='POSICION' placement='top'>
                                                                <span>
                                                                <IconButton style={{marginRight:2}} onClick={handleClickMenuPosicion} color='primary'>
                                                                    <BorderVerticalIcon />
                                                                </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                        </Grid>
                                                    </React.Fragment>
                                                }
                                                
                                                <Grid item >
                                                    <Tooltip title='SELECT ALL' placement='top'>
                                                        <span>
                                                        <IconButton style={{position:'relative',  left:-4}} onClick={handleSelectionAll} color='primary'>
                                                            <CheckBoxIcon />
                                                        </IconButton>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                {
                                                    selectionArr.length > 0 &&
                                                    <React.Fragment>
                                                        <Grid item>
                                                            <Chip label={`$ ${selectionArr.map(el=> el.ValTotal ? parseInt(el.ValTotal, 10) : parseInt(el.ValPlan, 10) ).reduce((a,b)=> a + b, 0)}`} color='secondary' />
                                                        </Grid>
                                                        <Grid item >
                                                            <Tooltip title='DELETE ROWS' placement='top'>
                                                                <span>
                                                                <IconButton style={{marginRight:2}} onClick={handleDeleteMultiple} color='primary' >
                                                                    <DeleteIcon style={{color:'red'}}/>
                                                                </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                        </Grid>
                                                        <Grid item >
                                                            <Tooltip title='UNSELECT ROWS' placement='top'>
                                                                <span>
                                                                <IconButton style={{marginRight:2}} onClick={handleUnSelect} color='secondary' >
                                                                    <CheckBoxOutlineBlankIcon /> 
                                                                </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                        </Grid>
                                                    </React.Fragment>
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Tooltip title='ADD PROMISE' placement='top'>
                                                <span>
                                                <IconButton 
                                                    style={{ background:isSelectedZona?'dodgerblue' : 'gray', color:'#fff' }} 
                                                    size='small' onClick={handleOpenFormulario} 
                                                    color='primary' 
                                                    disabled={!isSelectedZona}
                                                >
                                                    <PlusOneIcon />
                                                </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Grid>
                                    </React.Fragment>
                            }
                            {
                                    widthWin === 'xl' ||  widthWin === 'lg' ||  widthWin === 'md' ?
                                    <Grid item md={2} sm={12} xs={12} style={{position:'relative', top:3}}>
                                        <Autocomplete
                                            id="Zona"
                                            options={dataZona.map(value=>value.Zona)}
                                            value={zonaSelected || ''}                              
                                            renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                            onChange={(e,value, reason)=>{
                                                if(reason ===  'clear'){
                                                    handleClearZona()
                                                }else{
                                                    handleSelectZona(value);
                                                }
                                            }}  
                                        />
                                    </Grid>:null
                            }
                        </Grid>
                    </Grid>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12} >
                        <Paper square style={{minHeight:'75vh',  maxHeight:'75vh', width:'100%'}}>
                            { isSavingHeaders ? 
                            <Grid container>
                                <Grid item xl={12} lg={12} md={12} sm={12} xs={12} style={{height:'100%', display:'flex', justifyContent:'center', marginTop:'33vh'}}  >                                                                                                                                                                                                                  
                                    <FacebookCircularProgress size={40} style={{alignSelf:'center'}}/>
                                </Grid>
                            </Grid>
                            :
                            <Fragment>
                            { isCharging && <LinearProgress color='secondary' /> }
                            { isProcesing &&  <LinearProgress color='primary' />}  
                            <TableContainerYounet>
                                <TableYounet>
                                    <EnhancedTableHead
                                        classes={classes}
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={rows.length}
                                        headCells={headersColumn}
                                    />               
                                    <TableBody>
                                        {stableSort( getContinuoUnSelect ? [] : rows, getComparator(order, orderBy))
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                return (
                                                    <Roow 
                                                        key={row._id} 
                                                        row={row} 
                                                        index={index} 
                                                        headCells={headersColumn} 
                                                        handleClickRow={handleClickRow}
                                                        handleDeleteRow={handleDeleteRow}
                                                        selectionArr={selectionArr}
                                                    />                                          
                                                );
                                            })}
                                    </TableBody>
                                </TableYounet>
                            </TableContainerYounet>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 15, 20, 25]}
                                component="div"
                                count={rows.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage='Filas'
                                
                            />
                            </Fragment>
                            }
                        </Paper>
                    </Grid>
                </Grid>
            </React.Fragment>
              
        )
    };

    function Elementos(props) {
        return (
            <SnackbarProvider maxSnack={3} hideIconVariant={false} dense anchorOrigin={{vertical: 'bottom',horizontal: 'center'}}>
                <Elemento widthWin={props.width}/>
            </SnackbarProvider>
        );
    };

    export default withWidth()(Elementos);
